import 'babel-polyfill';
import './PolyFills/ElementMatches.js';
import './PolyFills/forEach.js';
import './PolyFills/Before.js';
import './PolyFills/Append.js';
import './PolyFills/Closest.js';
import 'whatwg-fetch';
import './controller';

import styles from './app.css';
import './normalizeheight.js';
import './../Navigation/inert.js';
import './../Navigation/side-nav.js';
import './../Navigation/NavigationExpander.js';
import './../Blocks/FaqBlock/faqblock.js';
import './../Blocks/NewsBlock/newsselectionblock.js';
import './../Blocks/CarouselBlockSingle/carouselSingle.js';
import './../Blocks/CarouselBlockMultiple/carouselMultiple.js';
import './../Blocks/PictureGrid/picturegrid.js';
import './../search/quick-search.js';
import './contactForm.js';
import './cookie.js';
import './forms.js';
import './footer.js';
import './menu.js';
import './paginator.js';
import './cookieconsent.js';
import './hover.js';
import './../ImageArchive/ImageArchiveFilter.js';
//import './vanillajs-datepicker.js';
import './../Pages/EventsContainer/eventscontainer.js';

//Google Translate a11y fix
document.addEventListener("DOMContentLoaded", () => {
    var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            const gtDiv = mutation.target;
            if (gtDiv.classList.contains('converted')) return;
            gtDiv.classList.add('converted');
            const gtPlh = gtDiv.querySelector('.gt-plh');
            gtDiv.querySelector('a').innerHTML = gtPlh.outerHTML;
            gtPlh.parentElement.removeChild(gtPlh);
        });
    });

    var config = { attributes: false, childList: true, characterData: false };
    document.querySelectorAll('.gt-item').forEach((e) => {
        observer.observe(e, config);
  });

  function updateSearchFormId() {
    // Select both search forms
    var desktopSearchForm = document.querySelector('.header__search:not(.hidden-xs)');
    var mobileSearchForm = document.querySelector('.search--moby .header__search');

    // Remove existing ID from both forms
    if (desktopSearchForm) desktopSearchForm.removeAttribute("id");
    if (mobileSearchForm) mobileSearchForm.removeAttribute("id");

    // Assign the ID to the currently visible form
    if (window.innerWidth >= 768) {
      if (desktopSearchForm) desktopSearchForm.setAttribute("id", "cludo-search-form");
    } else {
      if (mobileSearchForm && !mobileSearchForm.closest('.hidden')) {
        mobileSearchForm.setAttribute("id", "cludo-search-form");
      }
    }
  }

  // Run on page load
  updateSearchFormId();

  // Run on window resize
  window.addEventListener("resize", updateSearchFormId);

  // If the mobile search is toggled dynamically, observe changes
  var observer2 = new MutationObserver(updateSearchFormId);
  var mobileSearchContainer = document.querySelector(".search--moby");

  if (mobileSearchContainer) {
    observer2.observe(mobileSearchContainer, { attributes: true, attributeFilter: ["class"] });
  }

});



// WEBPACK FOOTER //
// ./Components/Shared/app.js